import React from "react";
import "swiper/css";
import "swiper/css/navigation";
import "./styles.css";
import "react-photo-view/dist/react-photo-view.css";
import { Carousel } from "react-carousel-minimal";

const ProductSlider = ({ images }) => {
  const data =
    images?.map((image) => ({
      image: image.image_url,
    })) || [];

  const captionStyle = {
    fontSize: "1.5rem",
    fontWeight: "500",
  };

  const slideNumberStyle = {
    fontSize: "16px",
    fontWeight: "bold",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    color: "#fff",
    padding: "4px 8px",
    borderRadius: "4px",
  };

  return (
    <div className="w-full max-w-full lg:max-w-[800px] mx-auto">
      {data.length > 0 ? (
        <div className="w-full px-4 md:px-10 lg:px-10 ml-4">
          <Carousel
            data={data}
            time={3000}
            width="100%"
            height="500px"
            captionStyle={captionStyle}
            slideNumber={true}
            slideNumberStyle={slideNumberStyle}
            captionPosition="bottom"
            automatic={true}
            dots={true}
            pauseIconColor="white"
            pauseIconSize="40px"
            slideBackgroundColor="transparent"
            slideImageFit="cover"
            thumbnails={true}
            thumbnailWidth="80px"
            className="carousel-container"
            style={{
              textAlign: "center",
              width: "100%",
              maxHeight: "900px",
            }}
          />
        </div>
      ) : (
        <div className="flex flex-col justify-center items-center h-[400px] text-gray-500 border border-dashed border-gray-300 rounded-md">
          <p className="text-lg">No images found</p>
        </div>
      )}
    </div>
  );
};

export default ProductSlider;
